// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Form = require("../../../shared-browser/src/components/BrowserComponents_Form.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var FormalityCompat__PublicHelpers = require("re-formality/src/FormalityCompat__PublicHelpers.bs.js");

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XXLarge */6, /* Bold */2);
}

var text = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.textAlign("center"),
          tl: /* [] */0
        }));

var subtitle = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.textAlign("center"),
            tl: /* [] */0
          }
        }));

var Styles = {
  text: text,
  subtitle: subtitle
};

function WebComponents_PostAShiftForm$Title(Props) {
  var subtitle$1 = Props.subtitle;
  var title = Props.title;
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, {
                  className: text,
                  children: title
                }), Relude_Option.fold(null, (function (subtitle$2) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }), React.createElement(BrowserComponents_Text.make, {
                                    className: subtitle,
                                    children: subtitle$2
                                  }));
                  }), subtitle$1), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }));
}

var Title = {
  Styles: Styles,
  make: WebComponents_PostAShiftForm$Title
};

var buttonContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                tl: /* [] */0
              }),
          tl: /* [] */0
        }
      }
    });

var button = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.medium),
      tl: {
        hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.medium),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.flex({
                      NAME: "num",
                      VAL: 1.0
                    }),
                tl: {
                  hd: BrowserStyle.flexBasis(BrowserStyle.zero),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var Styles$1 = {
  buttonContainer: buttonContainer,
  button: button
};

function WebComponents_PostAShiftForm$Buttons(Props) {
  var backButtonTitleOpt = Props.backButtonTitle;
  var onBackButtonClick = Props.onBackButtonClick;
  var submitButtonDisabledOpt = Props.submitButtonDisabled;
  var submitButtonTitleOpt = Props.submitButtonTitle;
  var testIdPrefix = Props.testIdPrefix;
  var backButtonTitle = backButtonTitleOpt !== undefined ? backButtonTitleOpt : "Back";
  var submitButtonDisabled = submitButtonDisabledOpt !== undefined ? submitButtonDisabledOpt : false;
  var submitButtonTitle = submitButtonTitleOpt !== undefined ? submitButtonTitleOpt : "Next";
  var tmp = {
    actionPriority: /* LegacySecondary */2,
    className: button,
    onClick: (function (param) {
        return onBackButtonClick;
      }),
    title: backButtonTitle
  };
  var tmp$1 = Relude_Option.map((function (param) {
          return "BackButton" + param;
        }), testIdPrefix);
  if (tmp$1 !== undefined) {
    tmp.testId = Caml_option.valFromOption(tmp$1);
  }
  var partial_arg = Relude_IO.pure(undefined);
  var tmp$2 = {
    actionPriority: /* Primary */0,
    className: button,
    disabled: submitButtonDisabled,
    onClick: (function (param) {
        return Relude_Globals.$$const(partial_arg, param);
      }),
    title: submitButtonTitle,
    type_: "submit"
  };
  var tmp$3 = Relude_Option.map((function (param) {
          return "NextButton" + param;
        }), testIdPrefix);
  if (tmp$3 !== undefined) {
    tmp$2.testId = Caml_option.valFromOption(tmp$3);
  }
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: buttonContainer,
              children: null
            }, React.createElement(BrowserComponents_Button.make, tmp), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Button.make, tmp$2));
}

var Buttons = {
  Styles: Styles$1,
  make: WebComponents_PostAShiftForm$Buttons
};

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
        tl: /* [] */0
      }
    });

var Styles$2 = {
  container: container
};

function WebComponents_PostAShiftForm$Content(Props) {
  var backButtonTitle = Props.backButtonTitle;
  var children = Props.children;
  var onBackButtonClick = Props.onBackButtonClick;
  var submitButtonDisabled = Props.submitButtonDisabled;
  var submitButtonTitle = Props.submitButtonTitle;
  var subtitle = Props.subtitle;
  var testIdPrefix = Props.testIdPrefix;
  var title = Props.title;
  var tmp = {
    title: title
  };
  if (subtitle !== undefined) {
    tmp.subtitle = Caml_option.valFromOption(subtitle);
  }
  var tmp$1 = {
    onBackButtonClick: onBackButtonClick
  };
  if (backButtonTitle !== undefined) {
    tmp$1.backButtonTitle = Caml_option.valFromOption(backButtonTitle);
  }
  if (submitButtonDisabled !== undefined) {
    tmp$1.submitButtonDisabled = Caml_option.valFromOption(submitButtonDisabled);
  }
  if (submitButtonTitle !== undefined) {
    tmp$1.submitButtonTitle = Caml_option.valFromOption(submitButtonTitle);
  }
  if (testIdPrefix !== undefined) {
    tmp$1.testIdPrefix = Caml_option.valFromOption(testIdPrefix);
  }
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container,
              children: null
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  children: null
                }, React.createElement(WebComponents_PostAShiftForm$Title, tmp), children, React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    })), React.createElement(WebComponents_PostAShiftForm$Buttons, tmp$1));
}

var Content = {
  Styles: Styles$2,
  make: WebComponents_PostAShiftForm$Content
};

function container$1(overrideContainerWidthPercentOpt, param) {
  var overrideContainerWidthPercent = overrideContainerWidthPercentOpt !== undefined ? overrideContainerWidthPercentOpt : 40.0;
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
              tl: {
                hd: BrowserStyle.display("flex"),
                tl: {
                  hd: BrowserStyle.flexBasis(BrowserStyle.pct(overrideContainerWidthPercent)),
                  tl: {
                    hd: BrowserStyle.flexDirection(BrowserStyle.column),
                    tl: {
                      hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                      tl: {
                        hd: BrowserStyle.minWidth(BrowserStyle.zero),
                        tl: {
                          hd: BrowserStyle.mobileMedia({
                                hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
                                tl: {
                                  hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                                  tl: /* [] */0
                                }
                              }),
                          tl: {
                            hd: BrowserStyle.padding(BrowserStyle.Spacing.large),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

var Styles$3 = {
  container: container$1
};

function WebComponents_PostAShiftForm$LegacyForm(Props) {
  var backButtonTitle = Props.backButtonTitle;
  var children = Props.children;
  var onBackButtonClick = Props.onBackButtonClick;
  var overrideContainerWidthPercent = Props.overrideContainerWidthPercent;
  var submit = Props.submit;
  var submitButtonDisabled = Props.submitButtonDisabled;
  var submitButtonTitle = Props.submitButtonTitle;
  var subtitle = Props.subtitle;
  var testIdPrefix = Props.testIdPrefix;
  var title = Props.title;
  var tmp = {
    children: children,
    onBackButtonClick: onBackButtonClick,
    title: title
  };
  if (backButtonTitle !== undefined) {
    tmp.backButtonTitle = Caml_option.valFromOption(backButtonTitle);
  }
  if (submitButtonDisabled !== undefined) {
    tmp.submitButtonDisabled = Caml_option.valFromOption(submitButtonDisabled);
  }
  if (submitButtonTitle !== undefined) {
    tmp.submitButtonTitle = Caml_option.valFromOption(submitButtonTitle);
  }
  if (subtitle !== undefined) {
    tmp.subtitle = Caml_option.valFromOption(subtitle);
  }
  if (testIdPrefix !== undefined) {
    tmp.testIdPrefix = Caml_option.valFromOption(testIdPrefix);
  }
  return React.createElement("form", {
              className: container$1(overrideContainerWidthPercent, undefined),
              onSubmit: (function (param) {
                  return FormalityCompat__PublicHelpers.Dom.preventDefault(submit, param);
                })
            }, React.createElement(WebComponents_PostAShiftForm$Content, tmp));
}

var LegacyForm = {
  make: WebComponents_PostAShiftForm$LegacyForm
};

function WebComponents_PostAShiftForm(Props) {
  var backButtonTitle = Props.backButtonTitle;
  var children = Props.children;
  var onBackButtonClick = Props.onBackButtonClick;
  var onSubmit = Props.onSubmit;
  var overrideContainerWidthPercent = Props.overrideContainerWidthPercent;
  var submitButtonDisabled = Props.submitButtonDisabled;
  var submitButtonTitle = Props.submitButtonTitle;
  var subtitle = Props.subtitle;
  var testIdPrefix = Props.testIdPrefix;
  var title = Props.title;
  var tmp = {
    children: children,
    onBackButtonClick: onBackButtonClick,
    title: title
  };
  if (backButtonTitle !== undefined) {
    tmp.backButtonTitle = Caml_option.valFromOption(backButtonTitle);
  }
  if (submitButtonDisabled !== undefined) {
    tmp.submitButtonDisabled = Caml_option.valFromOption(submitButtonDisabled);
  }
  if (submitButtonTitle !== undefined) {
    tmp.submitButtonTitle = Caml_option.valFromOption(submitButtonTitle);
  }
  if (subtitle !== undefined) {
    tmp.subtitle = Caml_option.valFromOption(subtitle);
  }
  if (testIdPrefix !== undefined) {
    tmp.testIdPrefix = Caml_option.valFromOption(testIdPrefix);
  }
  return React.createElement(BrowserComponents_Form.make, {
              className: container$1(overrideContainerWidthPercent, undefined),
              onSubmit: onSubmit,
              children: React.createElement(WebComponents_PostAShiftForm$Content, tmp)
            });
}

var make = WebComponents_PostAShiftForm;

exports.Title = Title;
exports.Buttons = Buttons;
exports.Content = Content;
exports.Styles = Styles$3;
exports.LegacyForm = LegacyForm;
exports.make = make;
/* text Not a pure module */
